export type HeadlineLevel = 1 | 2 | 3 | 4 | 5 | 6;

export interface HeadlineProps {
    level: HeadlineLevel;
    className?: string;
    ariaLabel?: string;
    id?: string;
    tabIndex?: number;
    children: React.ReactNode;
}

export const Headline = (props: HeadlineProps) => {
    const Tag = `h${props.level}` as keyof HTMLElementTagNameMap;

    return (
        <Tag
            className={props.className}
            id={props.id}
            tabIndex={props.tabIndex}
            aria-label={props.ariaLabel}
        >
            {props.children}
        </Tag>
    );
};
